import Banner from "../../components/Banner";
import Collaborators from "../../components/Collaborators";
import Container from "../../components/Container";
import ContainerDivider from "../../components/ContainerDivider";
import Footer from "../../components/Footer";
import HeroSection from "../../components/HeroSection";
import Navbar from "../../components/Navbar";
import Ratio from "../../components/Ratio";
import React from "react";
import SampleBannerImageFile from "../../statics/img/banner-sample-01.jpg";
import ScheduleTable from "../../components/ScheduleTable";
import Slide01 from "../../statics/img/slide-01.jpg";
import Slide02 from "../../statics/img/slide-02.jpg";
import Slide03 from "../../statics/img/slide-03.jpg";
import Slide04 from "../../statics/img/slide-04.jpg";
import Slideshow from "../../components/Slideshow";
import Spacer from "../../components/Spacer";
import StatisticsShowcase from "../../components/StatisticsShowcase";
import SubscriptionSection from "../../components/SubscriptionSection";
import getTime from "../../helpers/getTime";
import useEvent from "../../hooks/useEvent";
import useLinks from "../../hooks/useLinks";

const Home = () => {
  const event = useEvent();
  const links = useLinks();

  return (
    <div className="HomePage">
      <Navbar />
      <HeroSection
        headline={{
          header: "Welcome to",
          title:
            event === "SEAADE"
              ? "SEAADE 2020"
              : event === "IADR"
              ? "IADR-SEA 2020"
              : "SEAADE-IADR-SEA 2020",
          subtitle:
            event === "SEAADE"
              ? "November 24-25, 2020"
              : event === "IADR"
              ? "November 26-27, 2020"
              : "November 24-27, 2020",
          description:
            "The very first virtual " +
            event +
            " meeting in ‘Dental education and research during COVID-19 pandemic’ theme.",
          anchor: {
            children: "Download Program Book",
            href: links.programBook,
            theme: "secondary",
          },
        }}
      >
        <div className="w-full lg:w-7/12 lg:p-12">
          <Ratio w={3} h={2}>
            {event === "IADR" ? (
              <Slideshow slides={[Slide01, Slide02, Slide03, Slide04]} />
            ) : getTime() > getTime("28 Nov 2020") ? null : (
              <div className="flex items-center justify-center w-full h-full">
                <video
                  className="w-full px-8"
                  src={links.introVideo}
                  preload="auto"
                  controls={true}
                  autoPlay={true}
                ></video>
              </div>
            )}
          </Ratio>
        </div>
      </HeroSection>
      <StatisticsShowcase
        data={[
          {
            className: "text-aqua",
            title: "Keynotes & Symposiums",
            value: 11,
            description:
              "Over 11 keynotes & symposiums contributed to this virtual conference.",
          },
          {
            className: "text-cream",
            title: "Abstracts",
            value: 104,
            description:
              "Insights from over 104 abstracts participated in dental researches across Asia-Pacific.",
          },
          {
            className: "text-black",
            title: "Awards",
            value: 6,
            description: "Over 6 awards given across SEA dental community.",
          },
        ]}
      />

      <ContainerDivider />

      {getTime() > getTime("28 Nov 2020") ? null : (
        <Container>
          <Spacer>
            <Banner
              header="Join us on"
              title="Our first ever all-online video conference."
              button={{
                to: `/${event}/virtual-room/1`,
                text: "Watch Live Conference",
                theme: "secondary",
              }}
              bgImage={SampleBannerImageFile}
            />
          </Spacer>
        </Container>
      )}

      <ScheduleTable />

      <Spacer>
        <ContainerDivider />
        <Collaborators />
      </Spacer>

      <SubscriptionSection />
      <Footer />
    </div>
  );
};

export default Home;
